import { Risk } from "./enum";

export const riskValues = Object.values(Risk);
